import { ThemeProvider } from '@/components/theme-provider';
import { Toaster } from '@/components/ui/sonner';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import '@xyflow/react/dist/style.css';
import axios from 'axios';
import { toast } from 'sonner';
import { OpenAPI } from './api';
import AppLayout from './layouts/AppLayout';
import './styles/tiptap.css';

export default function App() {
  // Create a new query client for the app.
  const [queryClient] = useState(() => new QueryClient());

  // axios interceptor to handle 401 and 400 errors.
  axios.interceptors.response.use(
    response => response,
    async error => {
      let message = 'An error occurred executing the operation.';

      if (error.response?.status === 401) {
        if (!error.config.__api_retry) {
          // Do one retry
          error.config.__api_retry = true;

          try {
            console.log('Preparing retry from interceptor on 401...');

            const token = await firebaseConnector.getCurrentUserToken(true);
            if (!token) {
              console.error('Failed to get refreshed token');
              return Promise.reject(error);
            }

            // Forced the refresh and now set the token and retry.
            OpenAPI.TOKEN = token;
            error.config.headers.Authorization = `Bearer ${token}`;

            console.log('Received and set new token');

            return axios(error.config); // Send the original request.
          } catch (e) {
            console.error('Failed to refresh token:', e);
            message = 'Failed to refresh tokens.';
            return Promise.reject(error);
          }
        }
      } else if (error.response?.status === 400) {
        message = 'The operation could not be completed.';
      }

      toast('An error occurred', { description: message, duration: 5000 });

      return Promise.reject(error);
    },
  );

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
        <Toaster />
        <AppLayout />
      </ThemeProvider>
    </QueryClientProvider>
  );
}
